import React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

const SidebarLink = styled(Link)`
    display: flex;
    align-items: center;
    padding: 20px;
    height: 60px;
    text-decoration: none;
    font-size: 14px;
     background: ${({ isActive }) => (isActive ? "#0080d4" : "transparent")};
    color: ${({ isActive }) => (isActive ? "white" : "#67707a")}; 
    transition: all 0.3s ease;

    &:hover {
        background: ${({ isActive }) => (isActive ? "#0080d4" : "transparent")}; 
        color: ${({ isActive }) => (isActive ? "white" : "white")}; 
    }
`;

const SidebarLabel = styled.span`
    margin-left: 16px;
`;

const SubMenu = ({ item }) => {
    const location = useLocation();

    return (
        <SidebarLink to={item.path} isActive={location.pathname === item.path}>
            {item.icon}
            <SidebarLabel>{item.title}</SidebarLabel>
        </SidebarLink>
    );
};

export default SubMenu;
